// extracted by mini-css-extract-plugin
export var copyableField = "_hl-4";
export var customerBadge = "_hl-0";
export var customerInfoTitle = "_hl-2";
export var details = "_hl-1";
export var dropdownContainer = "_hl-5";
export var dropdownImage = "_hl-6";
export var editAssigneeForm = "_hl-a";
export var editButton = "_hl-3";
export var email = "_hl-7";
export var hidden = "_hl-d";
export var input = "_hl-8";
export var saveButton = "_hl-b";
export var shopifyIcon = "_hl-c";
export var username = "_hl-9";